import {Button, Space} from "antd";
import {LiveClassCardV2} from "../card/v2";
import {StyledNoUpcomingCallBox} from "../../../calls/upcoming-calls/upcoming-calls.style";
import {useNavigate} from "react-router";
import {sortLiveEventsByTime} from "../../../../features/live-events";
import type {LiveEventListItem} from "../../../../features/live-events";

export interface UpcomingClassesV2Props {
  data: LiveEventListItem[];
}

function UpcomingClassesV2({data}: UpcomingClassesV2Props) {
  const navigate = useNavigate();

  const getCoverImage = (event: LiveEventListItem): string => {
    return event.coverImage || "/images/no-image-placeholder.png";
  };

  return (
    <>
      {data.length > 0 ? (
        <Space direction="vertical" size={29} style={{display: "flex"}}>
          {sortLiveEventsByTime(data).map((liveClass) => (
            <div key={liveClass.id}>
              <LiveClassCardV2
                key={liveClass.id}
                name={liveClass.name}
                hasPhysicalLocation={liveClass.hasPhysicalLocation}
                locationLat={liveClass.locationLat}
                locationLng={liveClass.locationLng}
                callPrice={liveClass.callPrice}
                callPriceCurrency={liveClass.callPriceCurrency}
                coverImage={getCoverImage(liveClass)}
                description={liveClass.description}
                eventId={liveClass.id}
                eventDate={liveClass.eventDate}
                eventTime={liveClass.eventTime}
                attendeesCount={liveClass.attendeesCount}
                statusName={liveClass.statusName}
              />
            </div>
          ))}
        </Space>
      ) : (
        <StyledNoUpcomingCallBox>
          <p className="info-text">
            You do not have any live event at the moment. Create a new live event to get
            started
          </p>
          <div>
            <Button
              onClick={() => navigate("/live-classes/new")}
              size="small"
              block
              type="primary"
              htmlType="button"
            >
              Create new live event
            </Button>
          </div>
        </StyledNoUpcomingCallBox>
      )}
    </>
  );
}

export {UpcomingClassesV2};
